import React from 'react';
import {LineupPlayerFinalTableHead} from 'components/organisms/lineup/components/desktop/lineup-players/component/lineup-player-final-table-head';
import {LineupPlayers as BaseLineupPlayers} from 'components/organisms/lineup/components/lineup-players';

class BaseLineupPlayersComponent extends BaseLineupPlayers {
    getPlayersView() {
        const {lineups, lineupId} = this.props;
        const lineup = lineups.getLineup(lineupId);

        return lineup.players.map((player) => this.getPlayerView(player, lineup));
    }

    render() {
        return (
            <table className="table">
                <tbody>
                    <tr>
                        <th className="td-pos">Pos</th>
                        <th>Name</th>
                        <th className="td-team">Opp</th>
                        <th className="td-salary">Salary</th>
                        <th className="td-fpts">Fpts</th>
                        <LineupPlayerFinalTableHead />
                        <th className="td-pown">pOwn%</th>
                        <th className="td-exchange" />
                    </tr>
                    {this.getPlayersView()}
                </tbody>
            </table>
        );
    }
}

export {BaseLineupPlayersComponent};
